import { PASSWORD_STRENGTH_COLORS } from '../constants/passwordReset'

export function measurePasswordStrength(pass: string): number {
  if (!pass) return 0
  let score = 0
  const letters: Record<string, number> = {}
  for (let i = 0; i < pass.length; i++) {
    const ch = pass[i]
    letters[ch] = (letters[ch] || 0) + 1
    score += 5.0 / letters[ch]
  }
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass),
  }
  let variationCount = 0
  for (const check of Object.values(variations)) {
    if (check) variationCount += 1
  }
  score += (variationCount - 1) * 10
  return Math.trunc(score)
}

/** Returns the 5 bar colors for the current password (visual only). */
export function strengthBarColors(password: string): string[] {
  const bars = Array.from({ length: 5 }, () => '#DDD')
  if (!password) return bars
  const score = measurePasswordStrength(password)
  let idx = 0
  if (score > 90) idx = 4
  else if (score > 70) idx = 3
  else if (score >= 40) idx = 2
  else if (score >= 20) idx = 1
  const color = PASSWORD_STRENGTH_COLORS[idx]
  const filled = idx + 1
  for (let n = 0; n < filled; n++) bars[n] = color
  return bars
}
